<template>
	<div>
		<vx-card class="my-8">
      <div class="filters">
        <vs-input
          v-model="searchedTemplateName"
          :label="$t('searchByName')"
          class="filters__input mb-4"
          icon="search"
          icon-after
          @input="updateTemplates"
        />
      </div>

			<div class="tab-text ">
				<vs-table :data="templateAnswers" max-items="10" pagination>
					<template slot="thead">
						<vs-th
							v-for="fil in tableHeaders"
							:style="'width:' + fil.width"
							:class="{
								'justify-center':
									fil.align && fil.align === 'center'
							}"
						>
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<template v-for="fil in tableHeaders">
								<vs-td
									v-if="fil.field === 'name'"
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									{{ tr.name }}
								</vs-td>

								<vs-td
									v-else-if="fil.field === 'message'"
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									<span v-html="tr[fil.field]" />
								</vs-td>

								<vs-td
									v-else-if="fil.field === 'actions'"
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									<div class="flex justify-center">
										<vs-custom-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											icon="edit"
											@click="setModelToEdit(tr)"
										>
											<feather-icon
												icon="EditIcon"
											></feather-icon>
										</vs-custom-button>
									</div>
								</vs-td>

								<vs-td
									v-else-if="tr[fil.field]"
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									{{ tr[fil.field] }}
								</vs-td>

								<vs-td
									v-else
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									...
								</vs-td>
							</template>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>

		<vs-prompt
			:active.sync="activeEditPrompt"
			:title="$t('addAnswer')"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
			class="template-popup"
			@cancel="closeEditAnswerModal"
			@accept="editAnswer"
		>
			<div class="con-exemple-prompt mb-3">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">
						{{ $t("responseText") }}
					</label>

					<div class="vs-con-input"></div>

					<CKEditor
						v-model="answerText"
						v-validate="'required|min:3'"
						name="message"
						class="mb-0"
					/>
				</div>

				<span class="text-danger text-sm">
					{{ errors.first("message") }}
				</span>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import debounce from "debounce";

export default {
	name: "SiteTemplateAnswers",

	mixins: [notifier, databaseManager],

	props: {
		templateAnswers: { required: true }
	},

	data() {
		return {
			tableHeaders: [],
			activeEditPrompt: false,
			selectedAnswerToEdit: null,
			loading: false,
      searchedTemplateName: '',
		};
	},

	computed: {
		answerText: {
			get() {
				return this.selectedAnswerToEdit
					? this.selectedAnswerToEdit.message
					: "";
			},
			set(val) {
				this.$set(this.selectedAnswerToEdit, "message", val);
			}
		}
	},

	methods: {
    updateTemplates: debounce(async function() {
				this.$emit('search-templates', this.searchedTemplateName)
    }, 300),

		closeEditAnswerModal() {
			this.activeEditPrompt = false;
			this.selectedAnswerToEdit = null;
		},

		async editAnswer() {
			const { id, message } = this.selectedAnswerToEdit;

			try {
				this.loading = true;
				const res = await this.dbEditWebsiteAnswer(id, message);

				if (!res) {
					return;
				}

        const arr = [...this.templateAnswers]

        for (const item of arr) {
          if (item.id === res.id) {
            item.message = res.message
          }
        }

        this.$emit('update:templateAnswers', arr)
			} catch (err) {
				console.error(err);
			} finally {
				this.loading = false;
			}
		},

		setModelToEdit(model) {
			this.selectedAnswerToEdit = JSON.parse(JSON.stringify(model));
			this.activeEditPrompt = true;
		}
	},

	created() {
		this.tableHeaders = [
			{
				field: "name",
				title: this.$t("name"),
				width: "20%"
			},
			{
				field: "message",
				title: this.$t("responseText"),
				width: "70%"
			},
			{
				field: "actions",
				title: this.$t("actions"),
				align: "center",
				width: "10%"
			}
		];
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables.scss";

.filters {
  &__input {
    .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}
  }
}
</style>
